import Keycloak from 'keycloak-js';

// Singleton Keycloak client. Constructed eagerly so axios and the auth provider
// share the same instance. The `init()` call happens once inside AuthProvider.
const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

export default keycloak;
